import { __assign } from "tslib";
import { CallType } from '../../domain';
export var createCallsApi = function (baseUrl, http) {
    var phoneCalls = "".concat(baseUrl, "/phoneCalls");
    var groupsStats = "".concat(baseUrl, "/stats/callGroups");
    var url = "".concat(baseUrl, "/calls");
    var statsUrl = "".concat(baseUrl, "/stats/calls");
    var getCallsDefaultDto = {
        callTypes: [CallType.CALLBACK, CallType.INBOUND]
    };
    var getPhoneCallsDefaultDto = {
        callTypes: [CallType.CALLBACK, CallType.INBOUND, CallType.OUTBOUND]
    };
    return {
        searchPhoneCalls: function (dto) {
            var params = __assign(__assign({}, getPhoneCallsDefaultDto), dto);
            return http.post("".concat(phoneCalls, "/search"), params);
        },
        adminSearchPhoneCalls: function (dto) {
            var params = __assign(__assign({}, getPhoneCallsDefaultDto), dto);
            return http.post("".concat(phoneCalls, "/search/admin"), params);
        },
        getGroupsStats: function (dto) {
            var params = __assign(__assign({}, getPhoneCallsDefaultDto), dto);
            return http.post(groupsStats, params);
        },
        searchCalls: function (dto) {
            var params = __assign(__assign({}, getCallsDefaultDto), dto);
            return http.post("".concat(url, "/search"), params);
        },
        getOverview: function (dto) {
            var callsFilters = dto.queueId ? { queueId: dto.queueId } : dto.locale ? { locale: dto.locale } : {};
            var callTypes = dto.callTypes || getCallsDefaultDto.callTypes;
            var callsFiltersParams = __assign(__assign(__assign({}, getCallsDefaultDto), callsFilters), { callTypes: callTypes });
            return http.post(statsUrl, __assign({}, callsFiltersParams));
        }
    };
};
//# sourceMappingURL=index.js.map